module.exports = __webpack_public_path__ + "static/KapraNeuePro-BoldExp-dae1c56259a4422d2da5a49eff223b56.woff";